import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const MerchantList = createAsyncThunk('admin-user', async (searchParams) => {
    let res = await dataService.GetAPI(`merchant-users/list?${(searchParams.toString())}`);
    return res
})
const merchantSlice = createSlice({

    name: 'merchant-list',
    initialState,
    reducers: {

    },
    extraReducers: {
        // register user
        [MerchantList.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [MerchantList.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data?.success_status){
                state.List=action?.payload?.data;
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [MerchantList.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const {  } = merchantSlice.actions;
export default merchantSlice.reducer